// extracted by mini-css-extract-plugin
export var orderSummary = "_on-0";
export var showMoreLessButton = "_on-1";